import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { Container, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { LOW_INVENTORY_RESET } from '../constants/reportConstants'

const InventoryReports = () => {
  // get all inventory
  // find low inventory items
  // display list sorted by manufacturer

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  useEffect(() => {
    if (!userInfo) {
      dispatch({ type: LOW_INVENTORY_RESET })
      navigate('/login')
    }
  }, [dispatch, navigate, userInfo])

  return (
    <Container className='my-3'>
      <h3 className='text-secondary'>Inventory Reports</h3>
      <hr />
      <ul>
        <li>
          <Link to='/reports/lowinventory'>
            <h4>Low Inventory Report</h4>{' '}
          </Link>
        </li>
        <li>
          <h4>Number of receipts issued</h4>
        </li>
      </ul>
      <Button
        className='btn btn-primary my-3'
        onClick={() => navigate('/inventory')}
      >
        To Inventory
      </Button>
    </Container>
  )
}

export default InventoryReports
